import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      position: relative;\n      display: inline-block;\n\n      input::-ms-clear,\n      input::-ms-reveal {\n        display: none;\n      }\n    "])));
  },
  toggleVisibility: function toggleVisibility() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      color: #000;\n      cursor: pointer;\n      opacity: 0.6;\n      user-select: none;\n\n      &:hover {\n        opacity: 1;\n      }\n    "])));
  },
  capsLockDetector: function capsLockDetector() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n      font-size: 9px;\n      margin-right: 8px;\n      color: #fff;\n      cursor: default;\n      background: #999;\n      padding: 2px 5px;\n      border-radius: 3px;\n      z-index: 9;\n      box-sizing: border-box;\n      line-height: normal;\n\n      &::before {\n        content: 'CapsLock';\n      }\n    "])));
  },
  iconWrapper: function iconWrapper() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n    "])));
  },
  eyeWrapperSmall: function eyeWrapperSmall(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      min-width: ", ";\n    "])), t.inputIconSizeSmall);
  },
  eyeWrapperMedium: function eyeWrapperMedium(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      min-width: ", ";\n    "])), t.inputIconSizeMedium);
  },
  eyeWrapperLarge: function eyeWrapperLarge(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      min-width: ", ";\n    "])), t.inputIconSizeLarge);
  }
});